import MDEditor from "@uiw/react-md-editor";
import { cn } from "@/lib/utils";
import "@uiw/react-md-editor/markdown-editor.css";

interface MarkdownEditorProps {
  value?: string;
  onChange?: (value?: string) => void;
  placeholder?: string;
  className?: string;
}

export function MarkdownEditor({
  value,
  onChange,
  placeholder,
  className,
}: MarkdownEditorProps) {
  return (
    <div className={cn("w-full", className)} data-color-mode="light">
      <MDEditor
        value={value}
        onChange={onChange}
        preview="edit"
        hideToolbar={false}
        height={200}
        data-placeholder={placeholder}
      />
    </div>
  );
}
